import React from 'react';
import styled from '@emotion/styled';

const FooterContainer = styled.footer`
  background: white;
  padding: 4rem 0 2rem;
  color: #4b5563;
`;

const FooterContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;

  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 2rem;
  font-size: 1.2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const Copyright = styled.div`
  color: #6b7280;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2rem;
    margin-top: 0;
  }
`;

const DevelopedBy = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const FooterLink = styled.a`
  color: #7c3aed;
  font-weight: 600;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    text-decoration: underline;
  }
`;

const TranspiledLink = styled(FooterLink)``;

const BuyMeCoffeeLink = styled(FooterLink)`
  display: inline-flex;
`;

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterBottom>
          <Copyright>
            © {currentYear} Qraft Code. All rights reserved.
          </Copyright>
          <FooterLinks>
            <DevelopedBy>
              Developed with ♥ by{' '}
              <TranspiledLink
                href="https://transpiled.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Transpiled
              </TranspiledLink>
            </DevelopedBy>
            <BuyMeCoffeeLink
              href="https://buymeacoffee.com/qraftcode"
              target="_blank"
              rel="noopener noreferrer"
              title="Support us on Buy Me a Coffee"
            >
              ☕ Buy Me a Coffee
            </BuyMeCoffeeLink>
          </FooterLinks>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
}
